import { render } from "./YAxis.vue?vue&type=template&id=631da84c"
import script from "./YAxis.vue?vue&type=script&lang=js"
export * from "./YAxis.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__